module.exports = __webpack_public_path__ + "img/gift_card_item_flower.54e46f20.svg";